import { defineMessages } from "react-intl";

export const messages = defineMessages({
	status: {
		id: "patient_list.status",
		defaultMessage: "Státusz"
	},
	name: {
		id: "patient_list.name",
		defaultMessage: "Név"
	},
	socialSecurityNumber: {
		id: "patient_list.social_security_number",
		defaultMessage: "TAJ szám"
	},

	ageLabel: {
		id: "patient_list.age",
		defaultMessage: "Életkor"
	},
	ageUnit: {
		id: "patient_list.age_unit",
		defaultMessage: "éves"
	},
	sex: {
		id: "patient_list.sex",
		defaultMessage: "Nem"
	},
	city: {
		id: "patient_list.city",
		defaultMessage: "Város"
	},
	weight: {
		id: "patient_list.weight",
		defaultMessage: "Súly"
	},
	bloodGroup: {
		id: "patient_list.bloodGroup",
		defaultMessage: "Vércsoport"
	},

	waitingListDaysLabel: {
		id: "patient_list.waiting_list_days_label",
		defaultMessage: "Várólistán"
	},
	waitingListDaysUnitDesktop: {
		id: "patient_list.waiting_list_days_unit_desktop",
		defaultMessage: "napja"
	},
	waitingListDaysUnitMobile: {
		id: "patient_list.waiting_list_days_unit_mobile",
		defaultMessage: "napja a várólistán"
	},
	urgency: {
		id: "patient_list.urgency",
		defaultMessage: "Sürgetve"
	},
	combinedTransplant: {
		id: "patient_list.combinedTransplant",
		defaultMessage: "Kombinált TX"
	}
});
